import moment from 'moment';
export default {
	ruleRequired: (value) => !!value || 'Field is required',
	validateNumber: (value) => !isNaN(value) || 'Only numbers accepted!',
	validationAlpha: (value) =>
		/^[a-zA-Z]+$/.test(value) || 'Only letters accepted!',
	validationAccepted: (value) =>
		value == 'yes' ||
		value == 'no' ||
		value == 1 ||
		'Value must be yes, no or 1',
	validationAfterD: (value, date) =>
		moment(value).isAfter(date) || 'Value must be after ' + date,
	validationAlphaDash: (value) =>
		/^[a-zA-Z_]+$/.test(value) || 'Only letters and dash are accepted!',
	validationAlphaNum: (value) =>
		/^[a-zA-Z0-9]+$/.test(value) || 'Only letters and numbers accepted!',
	validationBeforeD: (value, date) =>
		moment(value).isBefore(date) || 'Value must be before ' + date,
	validationBetweenXY: (value, date1, date2) =>
		value > date1 && value < date2,
	validationConfirmedFAndSameF: (value, recordValue) => value == recordValue,
	validationDifferentF: (value, recordValue) => value != recordValue,
	validationDate: (value, format) =>
		moment(value, format, true).isValid() ||
		'Value must be a valid date (' + format + ')',
	validationDateNullable: (value, format) => {
		if (value == null || value == '') return true;
		return (
			moment(value, format, true).isValid() ||
			'Value must be a valid date (' + format + ')'
		);
	},
	validationIn: (value, values) =>
		values.includes(value) || 'Value should be in ' + values,
	validationIntegerAndNumeric: (value) =>
		Number.isInteger(Number(value)) || 'Number must be integer and numeric', // isNaN(value) && ??
	validationIp: (value) => {
		if (!value) return true;
		else
			return (
				/^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/.test(value) ||
				'Enter an valid IP address'
			);
	},
	validationMaxX: (value, x) => value <= x,
	validationMinX: (value, x) => value >= x,
	validationNotIn: (value, values) =>
		!values.includes(value) || 'Value should not be in ' + values,
	validationRegex: (value, regex) =>
		new RegExp(regex).test(value) || 'Value is not valid',
	validationRequiredIf: (value) => !!value || 'Field is required',
	validationRequiredWith: (value, labels) =>
		!!value || 'Value is required when ' + labels + ' are filled',
	validationRequiredWithout: (value, labels) =>
		!!value || 'Value is required without ' + labels,
	validationRequiredWithoutAll: (value) => !!value,
	validationSize: (value, length) =>
		value.length == length || 'Value length must be exactly ' + length,
	validationUrl: (value) => {
		if (!value) return true;
		else
			try {
				new URL(value);
				return true;
			} catch {
				return false || 'Value is not a valid url';
			}
	},
	validationMaxOne: (value) => !!value,
	validationMaxOneIf: (value) => !!value,
	validationMaxOneUnless: (value) => !!value,

	validationBoolean: (value) =>
		value.toLowerCase() == 'true' ||
		value.toLowerCase() == 'false' ||
		'Value must be a boolean (True/False)',

	validationUUID: (value) =>
		/^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/.test(
			value
		) || 'Value is not a valid UUID',
};
